import { useI18n } from "../../i18n";

const TONE = {
  admin: "bg-brand text-navy", executive: "bg-vblue text-white", accounting: "bg-amber-100 text-amber-900",
  customer_service: "bg-sky-100 text-sky-900", sales_rep: "bg-emerald-100 text-emerald-900",
  customer_admin: "bg-brand text-navy", customer_ordering: "bg-slate-200 text-slate-800",
};

export const RoleBadge = ({ role, className = "" }) => {
  const { t } = useI18n();
  return (
    <span data-testid={`role-badge-${role}`} className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${TONE[role] || "bg-white/15 text-current ring-1 ring-current/20"} ${className}`}>
      {t(`ops.role.${role}`)}
    </span>
  );
};
